import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import JsonExcel from 'vue-json-excel'
import 'ant-design-vue/dist/antd.css'
import '@/styles/index.less'
import './icons/index'

Vue.use(Antd)
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
